var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7266 8.39331C12.62 8.39331 12.5133 8.35997 12.42 8.28664C9.73331 6.2133 6.25998 6.2133 3.57331 8.28664C3.35331 8.4533 3.03997 8.4133 2.87331 8.19997C2.70664 7.97997 2.74664 7.66664 2.95998 7.49998C6.01998 5.13331 9.9733 5.13331 13.0266 7.49998C13.2466 7.66664 13.2866 7.97997 13.1133 8.19997C13.0266 8.32663 12.88 8.39331 12.7266 8.39331Z",
    fill: "#2058E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 6.07331C14.56 6.07331 14.4534 6.03999 14.36 5.96666C10.4933 2.97999 5.50002 2.97999 1.64002 5.96666C1.42002 6.13332 1.10669 6.09332 0.940023 5.87999C0.773356 5.65999 0.813349 5.34664 1.02668 5.17998C5.26002 1.90664 10.7334 1.90664 14.9734 5.17998C15.1934 5.34664 15.2334 5.65999 15.06 5.87999C14.9667 6.00665 14.8134 6.07331 14.6667 6.07331Z",
    fill: "#2058E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4734 10.8267C11.3667 10.8267 11.26 10.7934 11.1667 10.7201C9.24671 9.23339 6.76005 9.23339 4.83338 10.7201C4.61338 10.8867 4.30004 10.8467 4.13338 10.6334C3.96671 10.4134 4.00671 10.1001 4.22005 9.93339C6.51338 8.16006 9.48005 8.16006 11.7734 9.93339C11.9934 10.1001 12.0334 10.4134 11.86 10.6334C11.7667 10.7601 11.6201 10.8267 11.4734 10.8267Z",
    fill: "#2058E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73345 13.2667C9.62678 13.2667 9.52011 13.2333 9.42678 13.16C8.56011 12.4866 7.43345 12.4866 6.56678 13.16C6.34678 13.3266 6.03345 13.2866 5.86678 13.0733C5.70011 12.8533 5.74011 12.54 5.95344 12.3733C7.19344 11.4133 8.79345 11.4133 10.0334 12.3733C10.2534 12.54 10.2934 12.8533 10.1201 13.0733C10.0334 13.1933 9.88678 13.2667 9.73345 13.2667Z",
    fill: "#2058E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/WifiIcon.86e0e2bc53db15509937afcfadd30a5e.svg";
export { ForwardRef as ReactComponent };